module.exports = __webpack_public_path__ + "img/astronaut500.4d17d458.svg";